import { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { AdminPublicInfo } from '../../Api/Admin/models'
import { GetCbuResponse } from '../../Api/CBU/models'
import { fetchStaticButton } from '../../Api/Buttons/Buttons'
import { Button } from '../../Api/Buttons/models'
import { addCoins, checkIfPromoUserHasPhone } from '../../Api/LoadPanel/LoadPanel';
import { useGetTimeForHistory } from './useGetTimeForHistory';
import toast from 'react-hot-toast';

interface Props {
    adminInfo: AdminPublicInfo | null
    setForm: (form: any) => void
    setLoading: (loading: boolean) => void
    setDropdownOpen: (dropdownOpen: boolean) => void
    fetchedData: GetCbuResponse | null
    form: any
    loading: boolean
    setHistorial: (historial: any[]) => void
    historial: any[]
    setErrorQuantities: (errorQuantities: number) => void
    errorQuantities: number
    showHistory: boolean
    setShowHistory: (showHistory: boolean) => void
    setSelectedPlayerToUpdate: (selectedPlayerToUpdate: any) => void
    setShowCompletePlayerInfoModal: (showCompletePlayerInfoModal: boolean) => void
    setLastUploadedValue: (lastUploadedValue: number) => void
}



export const useLoadCoins = ({
    adminInfo,
    setForm,
    setLoading,
    setDropdownOpen,
    fetchedData,
    form,
    loading,
    setHistorial,
    historial,
    setErrorQuantities,
    errorQuantities,
    showHistory,
    setShowHistory,
    setSelectedPlayerToUpdate,
    setShowCompletePlayerInfoModal,
    setLastUploadedValue
}: Props) => {

    const { getTime } = useGetTimeForHistory()


    const [messagesAddCoins, setMessagesAddCoins] = useState<Button>({
        id: '',
        name: '',
        category: '',
        createdAt: '',
        updatedAt: '',
        OwnerId: '',
        Messages: []
    })

    const checkIfUserHasPhone = async ({ user }: { user: string }) => {
        try {
            const userHasPhone = await checkIfPromoUserHasPhone(user)
            if (!userHasPhone.data.status) {
                setSelectedPlayerToUpdate(userHasPhone.data.playerInfo)
                setShowCompletePlayerInfoModal(true)
                return;
            }
        } catch (error) {
            console.log(error)
        }
    }

    // CONFIRM ADD COINS
    const confirmAddCoins = async ({ isBonus }: { isBonus: boolean }) => {
        if (loading) { return }
        if (Number(form.quantity) < 1 || form?.name?.length < 1) { Swal.fire({ text: 'Debes introducir nombre y cantidad de fichas.' }); return }
        if (isNaN(Number(form.quantity))) {
            Swal.fire({ text: 'Debes introducir un número válido.' });
            return;
        }

        const formattedQuantity = Number(form.quantity)?.toLocaleString("es-ES", {
            maximumFractionDigits: 2,
        });

        if (adminInfo?.useMaxLoadValue && adminInfo?.maxLoadValue && (Number(form.quantity) >= adminInfo?.maxLoadValue)) {
            Swal.fire({
                html: `¿Estás por cargar <span style="color:var(--primary-color)">${formattedQuantity}</span> fichas ${isBonus ? 'con <span style="color:var(--primary-color)">100% de bonificación</span>' : ''}  al usuario <span style="color:var(--primary-color)">${form.name}</span>, deseas continuar?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'var(--main-color)',
                confirmButtonText: 'Si, Cargar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    setLoading(true)
                    handleCoins({ isBonus });
                } else {
                    setLoading(false);
                    return;
                }

            });
        } else {
            handleCoins({ isBonus });
        }
    }



    // MAIN FUNCTION
    const handleCoins = async ({ isBonus }: { isBonus: boolean }) => {
        setLoading(true)

        const values = {
            name: form.name?.trim(),
            quantity: form.quantity,
            senderName: form.senderName?.trim(),
            destinationAccountName: form.destinationAccountName?.trim()
        }

        setLastUploadedValue(Number(form.quantity))

        setForm({
            name: '',
            quantity: '',
            senderName: '',
            destinationAccountName: fetchedData?.titular ?? ''
        })

        const copyMessage = async (text: string) => {
            let updatedMessage = text
                .replaceAll('__CANTIDAD__', form.quantity)
                .replaceAll('__USUARIO__', form.name)
                .replaceAll('__PASSWORD__', adminInfo?.default_users_password ?? 'hola123')
                .replaceAll('__LINK__', `${adminInfo?.pageLink}`)


            await navigator.clipboard.writeText(updatedMessage);
        }

        let randomIndex = Math.floor(Math.random() * messagesAddCoins?.Messages?.length);
        let randomValue = messagesAddCoins?.Messages[randomIndex];
        if (randomValue) copyMessage(randomValue.text)
        setDropdownOpen(false);

        try {
            const result = await addCoins({
                name: values.name,
                quantity: values.quantity,
                isBonus: isBonus ? true : false,
                destinationAccountName: values.destinationAccountName,
                senderName: values.senderName
            })

            if (result?.data?.success) {
                toast.success(`${values.quantity} fichas cargadas a ${values.name}`)
                let record = { user: values.name, quantity: values.quantity, hour: getTime(), success: true, type: 'normal' }
                setHistorial([...historial, record])


                if (adminInfo?.currentlyInPromo) {
                    checkIfUserHasPhone({ user: values.name })
                }

            } else {
                let record = { user: values.name, quantity: values.quantity, hour: getTime(), success: false, info: result.data, type: 'normal' }
                setHistorial([...historial, record])
                if (!showHistory) setErrorQuantities(errorQuantities + 1)
                const errorMessage = result?.response?.data?.message ?? 'Ha habido un error. Reinicia e intenta de nuevo.'
                Swal.fire({ icon: 'error', text: errorMessage });
            }

        } catch (error: any) {
            let errorMessage = error?.response?.data?.message ?? 'ERROR: No se ha podido cargar, verifica tu conexión y que tengas fichas disponibles.'
            let record = { user: values.name, quantity: values.quantity, hour: getTime(), success: false, info: errorMessage, type: 'normal' }
            setHistorial([...historial, record])
            if (!showHistory) setErrorQuantities(errorQuantities + 1)
            Swal.fire({ icon: 'error', text: errorMessage });
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        fetchStaticButton('static_add').then((res) => {
            setMessagesAddCoins(res)
        })
    }, [])

    return {
        confirmAddCoins,
        historial,
        errorQuantities,
        showHistory,
        setShowHistory,
        setErrorQuantities,
        setShowCompletePlayerInfoModal
    }

}
